<div [formGroup]="paymentAccountForm" class="payment-account-selector">
  <p *ngIf="!paymentAccounts || paymentAccounts.length == 0">No payment accounts</p>
  <mat-form-field *ngIf="paymentAccounts && paymentAccounts.length > 0" appearance="outline">
    <mat-label>Select Payment Method</mat-label>
    <div class="payment-selector">
      <span class="selected-card-img" *ngIf="paymentAccount && paymentAccount.cardType"
        ><img with="20" height="20" [src]="cardImageHtml(paymentAccount.cardType)" />
      </span>
      <mat-select id="newPaymentDialog-select-selectPaymentAccount" class="option" formControlName="paymentAccount">
        <mat-option
          id="newPaymentDialog-option-paymentAccount-{{ paymentAccount.id }}"
          [value]="paymentAccount"
          class="option"
          *ngFor="let paymentAccount of paymentAccounts"
        >
          <img with="20" height="20" [src]="cardImageHtml(paymentAccount.cardType)" />
          <span id="paymentAccountSelector-text-cardNumber">ending in {{ paymentAccount.cardNumber }}</span>
          <span class="expiration">{{ paymentAccount.cardExpiration }}</span>
        </mat-option>
      </mat-select>
    </div>
  </mat-form-field>
</div>
